/**
 * @internalapi
 */
export var TransportType;
(function (TransportType) {
    TransportType["CHROME_MESSAGE"] = "chrome_message";
    TransportType["WALLETCONNECT"] = "walletconnect";
    TransportType["POST_MESSAGE"] = "post_message";
    TransportType["LEDGER"] = "ledger";
    TransportType["P2P"] = "p2p";
})(TransportType || (TransportType = {}));
//# sourceMappingURL=TransportType.js.map